import { request } from '..';
import { API_URL } from '../utils';

/* Requests */

export async function getAllFeatures(locale) {
  return request(`${API_URL}/rtd/podio/automation/getAllFeatures?locale=${locale}`, {
    method: 'GET',
  });
}

export async function getAllFeaturesByCategoryAndSubType(locale) {
  return request(`${API_URL}/rtd/podio/automation/getAllFeaturesByCategoryAndSubType?locale=${locale}`, {
    method: 'GET',
  });
}

export async function getFeaturesByCategoryAndSubType(slug, locale) {
  return request(
    `${API_URL}/rtd/podio/automation/getFeaturesByCategoryAndSubType/${slug}?locale=${locale}`,
    {
      method: 'GET',
    }
  );
}

export async function submitIntegrationRequest(email, phone, integrationType) {
  const parameters = {
    email,
    phone,
    integrationType,
  };

  return request(`${API_URL}/rtd/podio/automation/submitIntegrationRequest`, {
    method: 'POST',
    parameters,
  });
}
